import { render, staticRenderFns } from "./BlackActivationIncentive.vue?vue&type=template&id=3806112a&"
import script from "./BlackActivationIncentive.vue?vue&type=script&lang=js&"
export * from "./BlackActivationIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports